
import RequestService from "../util/request";
import { environment, getOnlineServices } from "../util";
import { assessmentLocation, DeviceMetrics, DeviceMetricsPatch, DeviceReadinessInfo, IADPState } from "../Types/AppStateTypes";
export function DeviceMetricsService() {
   const postDeviceMetrics=async (state: IADPState, deviceReadinessInfo: DeviceReadinessInfo,location?:assessmentLocation )=>{
     const onlineServiceConfig = getOnlineServices(state.appState.configuration);
     if(onlineServiceConfig && state.appState.appLaunchId && (state.sessionState.schoolDetails?.setupCode || state.sessionState.schoolDetails?.verificationCode))
     {
     let url = `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.postDeviceMetrics}`;
    const payload:DeviceMetrics={
            data: {
                clientLaunchId: state.appState.appLaunchId ?? "NotAvailable",
                appAccessedFor: state.sessionState.appAccessedFor,
                deviceModel: state.deviceState.deviceModel || "chromebook",
                setupCode:state.sessionState.schoolDetails.setupCode?.toUpperCase(),
                verificationCode: state.sessionState.schoolDetails.verificationCode?.toUpperCase(),
                assessmentDeliveryMode:"online",//TODO make this adjustable for Npn mode
                connectionType: "Internet",//TODO make this adjustable for Npn mode
                launchAgent: window.navigator.userAgent || "NotAvailable",
                readinessCheckInfo: deviceReadinessInfo ? deviceReadinessInfo : state.deviceReadinessState.deviceReadinessInfo,
                statusInfo: {
                    currentBatteryCharge: state.deviceState.batteryState.level?.toString() || "0",
                    lastUpdatedAt: new Date().toISOString()
                }  
            },
            clientDetails: {
                appName: "ng-enaep-student-app",
                appVersion: state.appState.appVersion || "NotAvailable",
                deviceDetails: {
                    deviceType: state.deviceState.deviceType || "SBE",
                    deviceId: state.deviceState.deviceId || "NotAvailable",
                    operatingSystem: window.navigator.userAgent.includes("Windows") ? "Windows" : "chromeOS"
                }
            }
        }
     if(location){
        payload.data.assessmentLocation = location;
     }
     const isDeviceMetricsPosted = RequestService.postDeviceMetrics(payload,`${url}/${state.appState.appLaunchId}` as string,false);
     return  isDeviceMetricsPosted
    }
   }
   const patchDeviceMetrics=(state: IADPState)=>{
    const onlineServiceConfig = getOnlineServices(state.appState.configuration);
    if(onlineServiceConfig && state.appState.appLaunchId && (state.sessionState.schoolDetails?.setupCode || state.sessionState.schoolDetails?.verificationCode))
    {
    const url = `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.postDeviceMetrics}`;
     console.log("patch", url)
    if(!state.sessionState.schoolDetails?.setupCode) return;
    const payload:DeviceMetricsPatch={
        data: {
            clientLaunchId: state.appState.appLaunchId ?? "NottAvailable",
            appAccessedFor: state.sessionState.appAccessedFor,
            setupCode:state.sessionState.schoolDetails.setupCode?.toUpperCase(),
            verificationCode: state.sessionState.schoolDetails.verificationCode?.toUpperCase(),
           connectionType: "Internet",//TODO make this adjustable for Npn mode
            launchAgent: window.navigator.userAgent || "NotAvailable",
            statusInfo: {
                currentBatteryCharge: state.deviceState.batteryState.level?.toString() || "0",
            }  
        },
        clientDetails: {
            appName: "ng-enaep-student-app",
            appVersion: state.appState.appVersion || "NotAvailable",
            deviceDetails: {
                deviceType: state.deviceState.deviceType || "SBE",
                deviceId: state.deviceState.deviceId || "NotAvailable",
                operatingSystem: window.navigator.userAgent.includes("Windows") ? "Windows" : "chromeOS"
            }
        }
        }
        RequestService.postDeviceMetrics(payload,`${url}/${state.appState.appLaunchId}` as string,true);
    }
   }
  
   return {postDeviceMetrics,patchDeviceMetrics}
}



